import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";
import { pollFirehoseAndIngest } from "./firehosePoller";

const firehoseSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.stream,
  connectionName: "Firehose-SSE",
  // Backend emits `event: ping` every ~20s of idle time. 45s threshold is the
  // recommended 2× heartbeat + buffer.
  activityTimeoutMs: 45000,
  fallbackThreshold: 5,
  pollingConfig: {
    pollingFn: pollFirehoseAndIngest,
    intervalMs: 10000,
  },
});

export default firehoseSSEClient;
